/**
 * 千牛 8 关配置驱动场景
 * 每关: { steps, initialStepId, initialForm }
 * 步骤: id, image, tip, hotspots[], fields[], isEnd, afterEnter?: { delay, go }, onEnter?
 */
function r(path) {
  return require('@/assets/images/newestqianniu/' + path)
}

export function getScenarioConfig() {
  return {
    first: {
      initialStepId: 'desktop',
      initialForm: { name: '', password: '', rnd: '' },
      steps: [
        {
          id: 'desktop',
          image: ({ ui }) => (ui.qnHover ? r('qnbg2.png') : r('qnbg1.png')),
          tip: '请点击<span style="color: red;font-weight:bold;">左侧练习场</span>中的千牛图标进行登录',
          hotspots: [
            { id: 'qnIcon', x: 0.20, y: 0.24, w: 0.04, h: 0.08, hoverSet: { qnHover: true }, hoverUnset: { qnHover: false }, next: 'desktop2' }
          ]
        },
        {
          id: 'desktop2',
          image: () => r('qnbg2.png'),
          tip: '请点击<span style="color: red;font-weight:bold;">左侧练习场</span>中的千牛图标进行登录',
          hotspots: [
            { id: 'qnDbl', on: 'dblclick', x: 0.20, y: 0.24, w: 0.04, h: 0.08, next: 'login' }
          ]
        },
        {
          id: 'login',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.78,
          image: ({ ui }) => {
            if (ui.saveChecked) return r('login3.png')
            if (ui.saveHover) return r('login2.png')
            return r('login1.png')
          },
          tip: '1.复制粘贴账号和密码<br>2.勾选记住密码',
          fields: [
            { id: 'name', model: 'name', type: 'text',bgColor: '#F6F7F9', placeholder: '请输入账号', x: 0.54, y: 0.44, w: 0.23, h: 0.05 },
            { id: 'pwd', model: 'password', type: 'password',bgColor: '#F6F7F9', placeholder: '请输入密码', autocomplete: 'new-password', x: 0.54, y: 0.54, w: 0.23, h: 0.05 }
          ],
          hotspots: [
            { id: 'save', x: 0.51, y: 0.80, w: 0.09, h: 0.03, hoverSet: { saveHover: true }, hoverUnset: { saveHover: false }, set: { saveChecked: true } },
            {
              id: 'loginBtn',
              x: 0.51, y: 0.71, w: 0.30, h: 0.08,
              guard: ({ form }) => {
                if (!form.name) return { ok: false, msg: '请输入账号' }
                if (form.name !== '淘金云客服:小淘') return { ok: false, msg: '用户名或密码错误，请注意大小写或特殊符号' }
                if (!form.password) return { ok: false, msg: '请输入密码' }
                if (form.password !== 'Tj1234') return { ok: false, msg: '用户名或密码错误，请注意大小写或特殊符号' }
                return { ok: true }
              },
              next: 'rnd'
            }
          ]
        },
        {
          id: 'rnd',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.78,
          image: ({ ui }) => {
            if (ui.rndShown) return r('loginrnd3.png')
            if (ui.rndHover) return r('loginrnd2.png')
            return r('loginrnd1.png')
          },
          tip: ({ ui }) =>
            ui.rndShown
              ? '短信校验码：<br><span style="color: red;font-weight:bold;">660220</span>'
              : '<span style="color: red;font-weight:bold;">获取短信校验码</span>',
          fields: [
            { id: 'rnd', model: 'rnd', type: 'text',bgColor: '#FFFFFF', placeholder: '短信校验码', x: 0.595, y: 0.35, w: 0.09, h: 0.05 }
          ],
          hotspots: [
            { id: 'sendRnd', x: 0.68, y: 0.355, w: 0.10, h: 0.05, hoverSet: { rndHover: true }, hoverUnset: { rndHover: false }, set: { rndShown: true } },
            {
              id: 'loginRndBtn',
              x: 0.53, y: 0.86, w: 0.25, h: 0.07,
              guard: ({ form }) => {
                if (!form.rnd) return { ok: false, msg: '请输入短信校验' }
                if (form.rnd !== '660220') return { ok: false, msg: '短信校验错误' }
                return { ok: true }
              },
              next: 'loginIndex'
            }
          ]
        },
        {
          id: 'loginIndex',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) =>
          ui.jdHover ? r('loginindex1.png') : r('loginindex2.png'),
          tip: '请进入<span style="color: red;font-weight:bold;">接待中心</span>',
          hotspots: [
            { id: 'enterJd', x: 0.94, y: 0.07, w: 0.02, h: 0.04, hoverSet: { jdHover: true }, hoverUnset: { jdHover: false }, next: 'done' }
          ]
        },
        {
          id: 'done',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('loginindex3.png'),
          tip: '请进入<span style="color: red;font-weight:bold;">接待中心</span>',
          isEnd: true
        }
      ]
    },

    second: {
      initialStepId: 's2_1',
      initialForm: {},
      steps: [
        {
          id: 's2_1',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('qnstatus1.png'),
          tip: '请将状态切换为“<span style="color: red;font-weight:bold;">在线</span>”状态',
          hotspots: [{ id: 'a', x: 0.09, y: 0.08, w: 0.05, h: 0.04, next: 's2_2' }]
        },
        {
          id: 's2_2',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.hover ? r('qnstatus3.png') : r('qnstatus2.png')),
          tip: '请将状态切换为“<span style="color: red;font-weight:bold;">在线</span>”状态',
          hotspots: [
            { id: 'b', x: 0.09, y: 0.12, w: 0.21, h: 0.05, hoverSet: { hover: true }, hoverUnset: { hover: false }, next: 's2_3' }
          ]
        },
        {
          id: 's2_3',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('qnstatus4.png'),
          tip: '请将状态切换为“<span style="color: red;font-weight:bold;">挂起</span>”状态',
          hotspots: [
            { id: 'c1', x: 0.09, y: 0.08, w: 0.05, h: 0.04, next: 's2_3b' }
          ]
        },
        {
          id: 's2_3b',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s2_3bhover ? r('qnstatus6.png') : r('qnstatus5.png')),
          tip: '请将状态切换为“<span style="color: red;font-weight:bold;">挂起</span>”状态',
          hotspots: [
            { id: 'c2', x: 0.09, y: 0.17, w: 0.21, h: 0.05, hoverSet: { s2_3bhover: true }, hoverUnset: { s2_3bhover: false }, next: 's2_3c' }
          ]
        },
        {
          id: 's2_3c',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('qnstatus7.png'),
          tip: '请将状态切换为“<span style="color: red;font-weight:bold;">挂起</span>”状态',
          hotspots: [{ id: 'c3', x: 0.54, y: 0.54, w: 0.05, h: 0.05, next: 's2_4' }]
        },
        {
          id: 's2_4',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('qnstatus1.png'),
          tip: '请将接待排序设置为：<span style="color: red;font-weight:bold;">按客户等待时长排序</span>',
          hotspots: [{ id: 'd', x: 0.17, y: 0.30, w: 0.07, h: 0.02, next: 's2_4b' }]
        },
        {
          id: 's2_4b',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s2_4bhover ? r('qnsort2.png') : r('qnsort1.png')),
          tip: '请将接待排序设置为：<span style="color: red;font-weight:bold;">按客户等待时长排序</span>',
          hotspots: [
            { id: 'e', x: 0.18, y: 0.385, w: 0.12, h: 0.04, hoverSet: { s2_4bhover: true }, hoverUnset: { s2_4bhover: false }, next: 's2_4c' }
          ]
        },
        {
          id: 's2_4c',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s2_4cHover ? r('qnset1.png') : r('qnsort3.png')),
          tip: '请进入<span style="color: red;font-weight:bold;">系统设置</span>中的<span style="color: red;font-weight:bold;">消息接收与提醒</span>，核对<span style="color: red;font-weight:bold;">店铺分流</span>和<span style="color: red;font-weight:bold;">账号分流</span>是否开启',
          hotspots: [
            { id: 'f', x: 0.84, y: 0.01, w: 0.03, h: 0.03, hoverSet: { s2_4cHover: true }, hoverUnset: { s2_4cHover: false }, next: 's2_4d' }
          ]
        },
        {
          id: 's2_4d',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s2_4dHover ? r('qnset3.png') : r('qnset2.png')),
          tip: '请进入<span style="color: red;font-weight:bold;">系统设置</span>中的<span style="color: red;font-weight:bold;">消息接收与提醒</span>，核对<span style="color: red;font-weight:bold;">店铺分流</span>和<span style="color: red;font-weight:bold;">账号分流</span>是否开启',
          hotspots: [
            { id: 'g', x: 0.85, y: 0.10, w: 0.08, h: 0.03, hoverSet: { s2_4dHover: true }, hoverUnset: { s2_4dHover: false }, next: 's2_4e' }
          ]
        },
        {
          id: 's2_4e',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s2_4eHover ? r('qnset5.png') : r('qnset4.png')),
          tip: '请进入<span style="color: red;font-weight:bold;">系统设置</span>中的<span style="color: red;font-weight:bold;">消息接收与提醒</span>，核对<span style="color: red;font-weight:bold;">店铺分流</span>和<span style="color: red;font-weight:bold;">账号分流</span>是否开启',
          hotspots: [
            { id: 'h', x: 0.09, y: 0.54, w: 0.07, h: 0.03, hoverSet: { s2_4eHover: true }, hoverUnset: { s2_4eHover: false }, next: 's2_done' }
          ]
        },
        {
          id: 's2_done',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('qnset6.png'),
          tip: '请进入<span style="color: red;font-weight:bold;">系统设置</span>中的<span style="color: red;font-weight:bold;">消息接收与提醒</span>，核对<span style="color: red;font-weight:bold;">店铺分流</span>和<span style="color: red;font-weight:bold;">账号分流</span>是否开启',
          isEnd: true
        }
      ]
    },

    third: {
      initialStepId: 's3_1',
      initialForm: { search: '', kjdybm: '', kjdynr: '', kjdyfz: '', kjdyfs: '' },
      steps: [
        {
          id: 's3_1',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy1.png'),
          tip: '请搜索登录账号<br><span style="color: red;font-weight:bold;">淘金云客服:小淘</span>',
          fields: [
            { id: 'search', model: 'search', bgColor: '#FFFFFF', fontSize: 12,type: 'text', placeholder: '联系人,订单号，聊天记录', x: 0.11, y: 0.135, w: 0.12, h: 0.04, onInput: ({ value, go }) => { if (value === '淘金云客服:小淘') setTimeout(() => go('s3_2'), 500) } }
          ],
          hotspots: []
        },
        {
          id: 's3_2',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy2.png'),
          tip: '请搜索登录账号<br><span style="color: red;font-weight:bold;">淘金云客服:小淘</span>',
          hotspots: [{ id: 'a', x: 0.1, y: 0.22, w: 0.2, h: 0.06, next: 's3_3' }]
        },
        {
          id: 's3_3',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s3_3hover ? r('kjdy4.png') : r('kjdy3.png')),
          tip: '请<span style="color: red;font-weight:bold;">打开快捷短语</span>',
          hotspots: [
            { id: 'b', x: 0.58, y: 0.67, w: 0.03, h: 0.03, hoverSet: { s3_3hover: true }, hoverUnset: { s3_3hover: false }, next: 's3_4' }
          ]
        },
        {
          id: 's3_4',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy5.png'),
          tip: '请<span style="color: red;font-weight:bold;">新增一条</span>快捷短语。<br>短语内容：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span><br> 编码：<span style="color: red;font-weight:bold;">欢迎</span><br>分组：<span style="color: red;font-weight:bold;">开头语</span>（需要自己新增分组）',
          hotspots: [{ id: 'c', x: 0.83, y: 0.28, w: 0.03, h: 0.03, next: 's3_5' }]
        },
        {
          id: 's3_5',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy6.png'),
          tip: '请<span style="color: red;font-weight:bold;">新增一条</span>快捷短语。<br>短语内容：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span><br> 编码：<span style="color: red;font-weight:bold;">欢迎</span><br>分组：<span style="color: red;font-weight:bold;">开头语</span>（需要自己新增分组）',
          fields: [
            { id: 'bm', model: 'kjdybm', bgColor: '#F6F8FA', fontSize: 12,type: 'text', placeholder: '快捷编码', x: 0.38, y: 0.535, w: 0.25, h: 0.035 },
            { id: 'nr', model: 'kjdynr', bgColor: '#F6F8FA', fontSize: 12,type: 'textarea', placeholder: '请输入快捷短语', x: 0.34, y: 0.35, w: 0.22, h: 0.12 }
          ],
          hotspots: [
            {
              id: 'd',
              x: 0.38, y: 0.59, w: 0.27, h: 0.035,
              next: 's3_6'
            }
          ]
        },
        {
          id: 's3_6',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s3_6hover ? r('kjdy8.png') : r('kjdy7.png')),
          tip: '请<span style="color: red;font-weight:bold;">新增一条</span>快捷短语。<br>短语内容：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span><br> 编码：<span style="color: red;font-weight:bold;">欢迎</span><br>分组：<span style="color: red;font-weight:bold;">开头语</span>（需要自己新增分组）',
          fields: [
            // 展示上一屏已输入的快捷编码与短语（可继续编辑）
            { id: 'bm_preview', model: 'kjdybm', bgColor: '#F6F8FA', fontSize: 12, type: 'text', placeholder: '快捷编码', x: 0.38, y: 0.535, w: 0.25, h: 0.035 },
            { id: 'nr_preview', model: 'kjdynr', bgColor: '#F6F8FA', fontSize: 12, type: 'textarea', placeholder: '请输入快捷短语', x: 0.34, y: 0.35, w: 0.22, h: 0.12 },
          ],
          hotspots: [
            { id: 'e', x: 0.39, y: 0.63, w: 0.26, h: 0.05, hoverSet: { s3_6hover: true }, hoverUnset: { s3_6hover: false }, next: 's3_7' }
          ]
        },
        {
          id: 's3_7',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.hover ? r('kjdy10.png') : r('kjdy9.png')),
          tip: '请<span style="color: red;font-weight:bold;">新增一条</span>快捷短语。<br>短语内容：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span><br> 编码：<span style="color: red;font-weight:bold;">欢迎</span><br>分组：<span style="color: red;font-weight:bold;">开头语</span>（需要自己新增分组）',
          fields: [{ id: 'fz2', model: 'kjdyfz', type: 'text',fontSize: 12, placeholder: '请输入分组', x: 0.41, y: 0.48, w: 0.22, h: 0.025 }],
          hotspots: [
            {
              id: 'f',
              x: 0.54, y: 0.54, w: 0.05, h: 0.05,
              guard: ({ form }) => (form.kjdyfz === '开头语' ? { ok: true } : { ok: false, msg: '分组名称应为: 开头语' }),
              next: 's3_8'
            }
          ]
        },
        {
          id: 's3_8',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy11.png'),
          tip: '请<span style="color: red;font-weight:bold;">新增一条</span>快捷短语。<br>短语内容：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span><br> 编码：<span style="color: red;font-weight:bold;">欢迎</span><br>分组：<span style="color: red;font-weight:bold;">开头语</span>（需要自己新增分组）',
          fields: [
            // 展示上一屏已输入的快捷编码与短语（可继续编辑）
            { id: 'bm_preview2', model: 'kjdybm', bgColor: '#F6F8FA', fontSize: 12, type: 'text', placeholder: '快捷编码', x: 0.38, y: 0.535, w: 0.25, h: 0.035 },
            { id: 'nr_preview2', model: 'kjdynr', bgColor: '#F6F8FA', fontSize: 12, type: 'textarea', placeholder: '请输入快捷短语', x: 0.34, y: 0.35, w: 0.22, h: 0.12 },
          ],
          hotspots: [
            {
              id: 'g',
              x: 0.56, y: 0.64, w: 0.05, h: 0.05,
              guard: ({ form }) => {
                if (form.kjdynr !== '亲，欢迎光临，请问有什么可以帮您的？') return { ok: false, msg: '请输入正确的快捷短语内容！' }
                if (form.kjdybm !== '欢迎') return { ok: false, msg: '请输入正确的编码' }
                return { ok: true }
              },
              next: 's3_9'
            }
          ]
        },
        {
          id: 's3_9',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy12.png'),
          tip: '请<span style="color: red;font-weight:bold;">先下载</span>快捷短语表格<span style="color: red;font-weight:bold;">并保存到桌面上</span>，再<span style="color: red;font-weight:bold;">导入</span>快捷短语。',
          hotspots: [{ id: 'h', x: 0.86, y: 0.28, w: 0.03, h: 0.03, next: 's3_10' }]
        },
        {
          id: 's3_10',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy13.png'),
          tip: '请<span style="color: red;font-weight:bold;">先下载</span>快捷短语表格<span style="color: red;font-weight:bold;">并保存到桌面上</span>，再<span style="color: red;font-weight:bold;">导入</span>快捷短语。',
          hotspots: [{ id: 'file', x: 0.50, y: 0.56, w: 0.03, h: 0.04, emit: 'request-file' }]
        },
        {
          id: 's3_11',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy14.png'),
          tip: '请<span style="color: red;font-weight:bold;">先下载</span>快捷短语表格<span style="color: red;font-weight:bold;">并保存到桌面上</span>，再<span style="color: red;font-weight:bold;">导入</span>快捷短语。',
          hotspots: [{ id: 'i', x: 0.63, y: 0.55, w: 0.04, h: 0.04, next: 's3_12' }]
        },
        {
          id: 's3_12',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s3_12hover ? r('kjdy16.png') : r('kjdy15.png')),
          tip: '请采用<span style="color: red;font-weight:bold;">鼠标左键</span>点击快捷短语的方式，选择并<span style="color: red;font-weight:bold;">发送</span>快捷短语：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span>',
          hotspots: [
            { id: 'j', x: 0.70, y: 0.39, w: 0.24, h: 0.03, hoverSet: { s3_12hover: true }, hoverUnset: { s3_12hover: false }, next: 's3_13' }
          ]
        },
        {
          id: 's3_13',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy17.png'),
          tip: '请采用<span style="color: red;font-weight:bold;">鼠标左键</span>点击快捷短语的方式，选择并<span style="color: red;font-weight:bold;">发送</span>快捷短语：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span>',
          fields: [
            {
              id: 'enter',
              model: 's3_13_enter',
              type: 'text',
              placeholder: '',
              autoFocus: true,
              x: 0, y: 0, w: 1, h: 0.94,
              onEnter: ({ go }) => { go('s3_14') }
            }
          ],
          // 输入框本身覆盖了热点区域，保留 hotspot 作为兼容点击
          hotspots: [{ id: 'k', x: 0.56, y: 0.95, w: 0.05, h: 0.04, next: 's3_14' }]
        },
        {
          id: 's3_14',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy18.png'),
          tip: '请采用 <span style="color: red;font-weight:bold;">/+快捷编码</span>点击快捷短语的方式，选择<span style="color: red;font-weight:bold;">并发送</span>快捷短语：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span>',
          fields: [
            { id: 'fs', model: 'kjdyfs', type: 'textarea', placeholder: '', x: 0.26, y: 0.71, w: 0.35, h: 0.1, onInput: ({ value, go }) => { if (value === '/欢迎') go('s3_15') } }
          ],
          hotspots: []
        },
        {
          id: 's3_15',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy19.png'),
          tip: '请采用 <span style="color: red;font-weight:bold;">/+快捷编码</span>点击快捷短语的方式，选择<span style="color: red;font-weight:bold;">并发送</span>快捷短语：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span>',
          fields: [
            {
              id: 'enter',
              model: 's3_15_enter',
              type: 'text',
              placeholder: '',
              autoFocus: true,
              x: 0, y: 0.38, w: 1, h: 0.56,
              onEnter: ({ go }) => { go('s3_16') }
            }
          ],
          hotspots: [{ id: 'm', x: 0.29, y: 0.33, w: 0.43, h: 0.04, next: 's3_16' }]
        },
        {
          id: 's3_16',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy20.png'),
          tip: '请采用 <span style="color: red;font-weight:bold;">/+快捷编码</span>点击快捷短语的方式，选择<span style="color: red;font-weight:bold;">并发送</span>快捷短语：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span>',
          fields: [
            {
              id: 'enter',
              model: 's3_16_enter',
              type: 'text',
              placeholder: '',
              autoFocus: true,
              x: 0, y: 0, w: 1, h: 0.94,
              onEnter: ({ go }) => { go('s3_done') }
            }
          ],
          // 输入框本身覆盖了热点区域，保留 hotspot 作为兼容点击
          hotspots: [{ id: 'n', x: 0.56, y: 0.95, w: 0.05, h: 0.04, next: 's3_done' }]
        },
        {
          id: 's3_done',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('kjdy21.png'),
          tip: '请采用 <span style="color: red;font-weight:bold;">/+快捷编码</span>点击快捷短语的方式，选择<span style="color: red;font-weight:bold;">并发送</span>快捷短语：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span>',
          isEnd: true
        }
      ]
    },

    four: {
      initialStepId: 's4_1',
      initialForm: { zjyy: '' },
      steps: [
        {
          id: 's4_1',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('cygn1.png'),
          tip: '请给当前用户标记<span style="color: red;font-weight:bold;">黄色星星</span>',
          hotspots: [{ id: 'a', on: 'mouseenter', x: 0.23, y: 0.36, w: 0.02, h: 0.03, next: 's4_2' }]
        },
        {
          id: 's4_2',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s4_2hover ? r('cygn3.png') : r('cygn2.png')),
          tip: '请给当前用户标记<span style="color: red;font-weight:bold;">黄色星星</span>',
          hotspots: [
            { id: 'b', x: 0.2, y: 0.2, w: 0.3, h: 0.15, hoverSet: { s4_2hover: true }, hoverUnset: { s4_2hover: false }, next: 's4_3' }
          ]
        },
        {
          id: 's4_3',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('cygn4.png'),
          tip: '请给当前用户标记<span style="color: red;font-weight:bold;">黄色星星</span>',
          afterEnter: { delay: 2500, go: 's4_4' }
        },
        {
          id: 's4_4',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s4_4hover ? r('cygn6.png') : r('cygn5.png')),
          tip: '请将当前用户<span style="color: red;font-weight:bold;">转发</span>给<span style="color: red;font-weight:bold;">小金</span>，转交原因填写<span style="color: red;font-weight:bold;">少件</span>',
          hotspots: [
            { id: 'c', x: 0.54, y: 0.14, w: 0.02, h: 0.03, hoverSet: { s4_4hover: true }, hoverUnset: { s4_4hover: false }, next: 's4_5' }
          ]
        },
        {
          id: 's4_5',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('cygn7.png'),
          tip: '请将当前用户<span style="color: red;font-weight:bold;">转发</span>给<span style="color: red;font-weight:bold;">小金</span>，转交原因填写<span style="color: red;font-weight:bold;">少件</span>',
          hotspots: [{ id: 'd', x: 0.56, y: 0.34, w: 0.21, h: 0.04, next: 's4_6' }]
        },
        {
          id: 's4_6',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('cygn8.png'),
          tip: '请将当前用户<span style="color: red;font-weight:bold;">转发</span>给<span style="color: red;font-weight:bold;">小金</span>，转交原因填写<span style="color: red;font-weight:bold;">少件</span>',
          fields: [
            { id: 'zjyy', model: 'zjyy', type: 'text', bgColor: '#F7F8FA', fontSize: 12, placeholder: '请输入转交原因', x: 0.80, y: 0.58, w: 0.09, h: 0.04 }
          ],
          hotspots: [
            {
              id: 'e',
              x: 0.89, y: 0.58, w: 0.03, h: 0.04,
              guard: ({ form }) => (form.zjyy === '少件' ? { ok: true } : { ok: false, msg: '请输入正确的转交原因' }),
              next: 's4_done'
            }
          ]
        },
        {
          id: 's4_done',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('cygn10.png'),
          tip: '请将当前用户<span style="color: red;font-weight:bold;">转发</span>给<span style="color: red;font-weight:bold;">小金</span>，转交原因填写<span style="color: red;font-weight:bold;">少件</span>',
          isEnd: true
        }
      ]
    },

    five: {
      initialStepId: 's5_1',
      initialForm: {},
      steps: [
        {
          id: 's5_1',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s5_1hover ? r('tjsp2.png') : r('tjsp1.png')),
          tip: '请将<span style="color: red;font-weight:bold;">商品导购区</span>客户<span style="color: red;font-weight:bold;">足迹</span>中<span style="color: red;font-weight:bold;">符合客户需求</span>的商品发送给客户',
          hotspots: [
            { id: 'a', x: 0.70, y: 0.56, w: 0.05, h: 0.08, hoverSet: { s5_1hover: true }, hoverUnset: { s5_1hover: false }, next: 's5_2' }
          ]
        },
        {
          id: 's5_2',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s5_2hover ? r('tjsp4.png') : r('tjsp3.png')),
          tip: '请将<span style="color: red;font-weight:bold;">商品导购区</span>客户<span style="color: red;font-weight:bold;">足迹</span>中<span style="color: red;font-weight:bold;">符合客户需求</span>的商品发送给客户',
          hotspots: [
            { id: 'b', x: 0.64, y: 0.94, w: 0.06, h: 0.04, hoverSet: { s5_2hover: true }, hoverUnset: { s5_2hover: false }, next: 's5_done' }
          ]
        },
        {
          id: 's5_done',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('tjsp5.png'),
          tip: '请将<span style="color: red;font-weight:bold;">商品导购区</span>客户<span style="color: red;font-weight:bold;">足迹</span>中<span style="color: red;font-weight:bold;">符合客户需求</span>的商品发送给客户',
          isEnd: true
        }
      ]
    },

    six: {
      initialStepId: 's6_1',
      initialForm: { yfamount: '0', bznr: '', phone: '18418966473-4839' },
      steps: [
        { 
          id: 's6_1', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('fkzt1.png'), 
          tip: '请将会话切换到<span style="color: red;font-weight:bold;">未付款客户</span>', 
          hotspots: [{ id: 'a', x: 0.09, y: 0.41, w: 0.15, h: 0.06, next: 's6_2' }] 
        },
        { 
          id: 's6_2', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('fkzt2.png'), 
          tip: '请将会话切换到<span style="color: red;font-weight:bold;">已付款</span>客户', 
          hotspots: [{ id: 'b', x: 0.09, y: 0.48, w: 0.15, h: 0.06, next: 's6_3' }] 
        },
        { 
          id: 's6_3', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('fkzt3.png'), 
          tip: '请将会话切换到<span style="color: red;font-weight:bold;">已发货</span>待收货<span style="color: red;font-weight:bold;">客户</span>', 
          hotspots: [{ id: 'b', x: 0.09, y: 0.54, w: 0.15, h: 0.06, next: 's6_4' }] 
        },
        { 
          id: 's6_4', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('fkzt4.png'), 
          tip: '请将会话切换到<span style="color: red;font-weight:bold;">已发货</span>待收货<span style="color: red;font-weight:bold;">客户</span>', 
          hotspots: [],
          afterEnter: { delay: 2500, go: 's6_5' }
        },
        { 
          id: 's6_5', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('ck1.png'), 
          tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">催付</span>按钮，给客户发送催付卡片', 
          hotspots: [{ id: 'b', x: 0.70, y: 0.88, w: 0.05, h: 0.04, next: 's6_6' }],
        },
        { 
          id: 's6_6', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('ck2.png'), 
          tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">催付</span>按钮，给客户发送催付卡片', 
          afterEnter: { delay: 2500, go: 's6_7' }
        },
        {
          id: 's6_7',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('xgyf1.png'),
          overlayImage: ({ ui }) => (ui.showYf ? r('yfalert1.png') : null),
          overlayScale: 0.7,
          tip: '请<span style="color: red;font-weight:bold;">根据聊天内容</span>在<span style="color: red;font-weight:bold;">订单操作区</span>的<span style="color: red;font-weight:bold;">改价</span>中<span style="color: red;font-weight:bold;">修改邮费</span>',
          fields: ({ ui }) =>
            ui.showYf
              ? [{ id: 'yf', model: 'yfamount', type: 'text', bgColor: '#F2F4F7', fontSize: '12',placeholder: '请输入邮费', x: 0.24, y: 0.63, w: 0.07, h: 0.04 }]
              : [],
          hotspots: ({ ui }) => {
            const list = [
              { id: 'showYf', x: 0.75, y: 0.88, w: 0.06, h: 0.04, set: { showYf: true } }
            ]
            if (ui.showYf) {
              list.push({
                id: 'yfBtn',
                x: 0.75, y: 0.78, w: 0.05, h: 0.05,
                guard: ({ form }) => (String(form.yfamount) === '8' ? { ok: true } : { ok: false, msg: '请输入正确的邮费' }),
                next: 's6_8'
              })
            }
            return list
          }
        },
        { 
          id: 's6_8', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('xgyf2.png'), 
          tip: '【假设商家要求<span style="color: red;font-weight:bold;">发顺丰</span>的客户插<span style="color: red;font-weight:bold;">红色</span>旗子】<span style="color: red;font-weight:bold;">请添加订单备注，并勾选对应的彩旗。</span><br>备注内容为：发顺丰',
          hotspots: [{ id: 'd', x: 0.85, y: 0.82, w: 0.03, h: 0.03, next: 's6_9' }] 
        },
        { 
          id: 's6_9', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('bz1.png'), 
          tip: '【假设商家要求<span style="color: red;font-weight:bold;">发顺丰</span>的客户插<span style="color: red;font-weight:bold;">红色</span>旗子】<span style="color: red;font-weight:bold;">请添加订单备注，并勾选对应的彩旗。</span><br>备注内容为：发顺丰',
          fields: [{ id: 'bz', model: 'bznr', type: 'textarea',bgColor: '#FFFFFF', fontSize: 12,placeholder: '请输入备注内容', x: 0.64, y: 0.70, w: 0.30, h: 0.06 }], 
          hotspots: [
            { id: 'e', x: 0.71, y: 0.54, w: 0.07, h: 0.03, next: 's6_10' }
          ] 
        },
        {
          id: 's6_10',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('bz2.png'),
          tip: '【假设商家要求<span style="color: red;font-weight:bold;">发顺丰</span>的客户插<span style="color: red;font-weight:bold;">红色</span>旗子】<span style="color: red;font-weight:bold;">请添加订单备注，并勾选对应的彩旗。</span><br>备注内容为：发顺丰',
          fields: [{ id: 'bz', model: 'bznr', type: 'textarea',bgColor: '#FFFFFF', fontSize: 12,placeholder: '请输入备注内容', x: 0.64, y: 0.70, w: 0.30, h: 0.06 }], 
          hotspots: [
            {
              id: 'f',
              x: 0.84, y: 0.95, w: 0.05, h: 0.04,
              guard: ({ form }) => (form.bznr === '发顺丰' ? { ok: true } : { ok: false, msg: '请输入正确的备注' }),
              next: 's6_11'
            }
          ]
        },
        { 
          id: 's6_11', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('bz3.png'), 
          tip: '【假设商家要求<span style="color: red;font-weight:bold;">发顺丰</span>的客户插<span style="color: red;font-weight:bold;">红色</span>旗子】<span style="color: red;font-weight:bold;">请添加订单备注，并勾选对应的彩旗。</span><br>备注内容为：发顺丰',
          afterEnter: { delay: 2500, go: 's6_12' } 
        },
        { 
          id: 's6_12', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('hddd1.png'), 
          tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">核对订单</span>按钮，给客户发送订单卡片', 
          hotspots: [{ id: 'g', x: 0.64, y: 0.88, w: 0.06, h: 0.04, next: 's6_13' }] 
        },
        { 
          id: 's6_13', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('hddd2.png'), 
          tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">核对订单</span>按钮，给客户发送订单卡片', 
          afterEnter: { delay: 2500, go: 's6_14' } 
        },
        { 
          id: 's6_14', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('xgdh1.png'), 
          tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">改址</span>按钮，修改客户电话', 
          hotspots: [{ id: 'h', x: 0.70, y: 0.52, w: 0.05, h: 0.03, next: 's6_15' }] 
        },
        {
          id: 's6_15',
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('xgdh2.png'),
          tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">改址</span>按钮，修改客户电话', 
          labels: [
            { id: 'phoneLabel', text: '13656565656', x: 0.30, y: 0.42, w: 0.07, h: 0.04, color: '#000', fontWeight: 'normal', fontSize: 13, bgColor: '#FFFFFF', selectable: true }
          ],
          fields: [{ id: 'phone', model: 'phone',bgColor:'#F7F8FA', type: 'text', placeholder: '请输入', x: 0.75, y: 0.78, w: 0.15, h: 0.05 }],
          hotspots: [
            {
              id: 'i',
              x: 0.84, y: 0.94, w: 0.08, h: 0.05,
              guard: ({ form }) => (form.phone === '13656565656' ? { ok: true } : { ok: false, msg: '请输入正确的电话号码！' }),
              next: 's6_done'
            }
          ]
        },
        { id: 's6_done', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('xgdh1.png'), 
          tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">改址</span>按钮，修改客户电话', 
          isEnd: true }
      ]
    },

    seven: {
      initialStepId: 's7_1',
      initialForm: {},
      steps: [
        { 
          id: 's7_1', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s7_1hover ? r('shcygn2.png') : r('shcygn1.png')), 
          tip: '请进入<span style="color: red;font-weight:bold;">工作台</span></span>', 
          hotspots: [{ id: 'a', x: 0.04, y: 0.16, w: 0.04, h: 0.06, hoverSet: { s7_1hover: true },  hoverUnset: { s7_1hover: false }, next: 's7_2' }] 
        },
        { 
          id: 's7_2', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('shcygn3.png'), 
          tip: '请进入<span style="color: red;font-weight:bold;">交易→已卖出宝贝</span></span>', 
          hotspots: [{ id: 'b', x: 0.01, y: 0.18, w: 0.05, h: 0.04, next: 's7_3' }] 
        },
        { 
          id: 's7_3', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s7_3hover ? r('shcygn5.png') : r('shcygn4.png')), 
          tip: '请进入<span style="color: red;font-weight:bold;">交易→已卖出宝贝</span></span>', 
          hotspots: [{ id: 'c', x: 0.08, y: 0.24, w: 0.07, h: 0.04, hoverSet: { s7_3hover: true }, hoverUnset: { s7_3hover: false }, next: 's7_4' }] 
        },
        { 
          id: 's7_4', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s7_4hover ? r('shcygn7.png') : r('shcygn6.png')), 
          tip: '请进入<span style="color: red;font-weight:bold;">评价管理</span></span>', 
          hotspots: [{ id: 'd', x: 0.08, y: 0.31, w: 0.07, h: 0.04, hoverSet: { s7_4hover: true }, hoverUnset: { s7_4hover: false }, next: 's7_5' }] 
        },
        { 
          id: 's7_5', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s7_5hover ? r('shcygn9.png') : r('shcygn8.png')), 
          tip: '请进入<span style="color: red;font-weight:bold;">退款管理</span></span>', 
          hotspots: [{ id: 'e', x: 0.08, y: 0.38, w: 0.07, h: 0.04, hoverSet: { s7_5hover: true }, hoverUnset: { s7_5hover: false }, next: 's7_done' }] 
        },
        { 
          id: 's7_done', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('shcygn10.png'), 
          tip: '请进入<span style="color: red;font-weight:bold;">退款管理</span></span>', 
          isEnd: true 
        }
      ]
    },

    eight: {
      initialStepId: 's8_1',
      initialForm: {},
      steps: [
        { 
          id: 's8_1', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('tcqn1.png'), 
          tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>', 
          hotspots: [{ id: 'a', x: 0.09, y: 0.08, w: 0.05, h: 0.03, next: 's8_2' }] 
        },
        { 
          id: 's8_2', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s8_2hover ? r('tcqn3.png') : r('tcqn2.png')), 
          tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>', 
          hotspots: [{ id: 'b', x: 0.10, y: 0.17, w: 0.20, h: 0.05, hoverSet: { s8_2hover: true }, hoverUnset: { s8_2hover: false }, next: 's8_3' }] 
        },
        { 
          id: 's8_3', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('tcqn4.png'), 
          tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>', 
          hotspots: [{ id: 'c', x: 0.54, y: 0.54, w: 0.25, h: 0.05, next: 's8_4' }] 
        },
        { 
          id: 's8_4', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('tcqn5.png'), 
          tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>', 
          hotspots: [{ id: 'd', x: 0.09, y: 0.08, w: 0.05, h: 0.03, next: 's8_5' }] 
        },
        { 
          id: 's8_5', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: ({ ui }) => (ui.s8_5hover ? r('tcqn7.png') : r('tcqn6.png')), 
          tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>', 
          hotspots: [{ id: 'e', x: 0.10, y: 0.28, w: 0.20, h: 0.04, hoverSet: { s8_5hover: true }, hoverUnset: { s8_5hover: false }, next: 's8_6' }] 
        },
        { 
          id: 's8_6', 
          stageBg: () => r('qnbg1.png'),
          canvasScale: 0.95,
          image: () => r('tcqn8.png'), 
          tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>', 
          hotspots: [{ id: 'e', x: 0.56, y: 0.57, w: 0.05, h: 0.06, next: 's8_done' }] 
        },
        { 
          id: 's8_done', 
          image: () => r('qnbg1.png'), 
          tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>', 
          isEnd: true 
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/simulate/newQianNiuScenarios.js